// extracted by mini-css-extract-plugin
export default {"hero":"Start_hero__fnTND","text":"Start_text__RmOaW"};